import fetch from 'isomorphic-fetch';
import { getEngineKey, getEngineUrl } from '../helpers/sysAttrs';

export const STORIES_FETCH_REQUEST = 'STORIES_FETCH_REQUEST';
export const STORIES_FETCH_SUCCESS = 'STORIES_FETCH_SUCCESS';
export const STORIES_FETCH_FAILURE = 'STORIES_FETCH_FAILURE';

export const STORIES_SEARCH_CHANGE = 'STORIES_SEARCH_CHANGE';

export const STORIES_PAGE_CHANGE = 'STORIES_PAGE_CHANGE';

/**
 * Performs swiftype API call for stories
 * Response is handled as JSON
 * In case of success triggers success action
 * In case of failure triggers failure action
 * Before request triggers request begin action
 */
export function fetchStories() {
    return (dispatch, getState) => {
        dispatch({ type: STORIES_FETCH_REQUEST });

        const { query, from, to, page } = getState().stories;
        return fetch(`${getEngineUrl()}/search.json`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({
                page,
                engine_key: getEngineKey(),
                q: query,
                per_page: 15,
                sort_direction: {},
                filters: {
                    page: {
                        type: 'stories',
                        published_at: {
                            from,
                            to,
                            type: 'range',
                        },
                    },
                },
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch stories');
                }
                return response.json();
            })
            .then(payload => dispatch({
                type: STORIES_FETCH_SUCCESS,
                payload,
            }))
            .catch((error) => {
                dispatch({
                    type: STORIES_FETCH_FAILURE,
                    error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * Change state of search form
 */
export function changeSearch(search) {
    return {
        type: STORIES_SEARCH_CHANGE,
        search,
    };
}

/**
 * Change page number
 */
export function changePage(page) {
    return {
        type: STORIES_PAGE_CHANGE,
        page,
    };
}



// WEBPACK FOOTER //
// ./src/js/Stories/stories.actions.js